<template>
  <div
    v-if="isVisible && isSnowing"
    class="xmas">
    <div class="snow" />
    <div class="snow snow--middle" />
    <div class="snow snow--upper" />
  </div>
</template>

<script setup>
import { isXmas } from '@/helpers/isXmas';
import store from '@/store';
import { computed } from 'vue';

const isVisible = isXmas();
const isSnowing = computed(() => store.state.xmas.isSnowing);
</script>

<style lang="sass">
.xmas
  display: block
  width: 100vw
  height: 100vh

  position: absolute
  left: 0
  top: 0
  z-index: 10

  overflow: hidden
  pointer-events: none

.snow
  display: block
  width: 100vw
  height: 100vh

  position: fixed
  left: 0
  top: 0
  z-index: 10

  pointer-events: none

  font-size: 100px

  background-image: url('@/assets/img/xmas/snow.webp')
  background-size: 3em 3em
  animation: snow 40s linear infinite

.snow--middle
  font-size: 200px

.snow--upper
  font-size: 400px

@keyframes snow
  0%
    background-position: 0 0
  33%
    background-position: 1em 3em
  33.0001%
    background-position: 1em 0
  66%
    background-position: 2em 3em
  66.0001%
    background-position: 2em 0
  99.9999%
    background-position: 3em 3em
  100%
    background-position: 0 0
</style>
